import Totals from "../../crew/Totals";
import GoldUpgrade from "./GoldUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";
import BigNumValue from "../../value/BigNumValue";
import BigNum from "../../math/BigNum";
import NumberFormatter from "../../../util/NumberFormatter";

export default class GoldBonusGoldUpgrade extends GoldUpgrade {
    /**
     * @param {string} id
     * @param {string} title
     * @param {string} iconFileName
     * @param {UpgradeCostCalculator} upgradeCostCalculator 
     * @param {number} maxCount
     * @param {Totals} totals
     * @param {BigNumValue} goldBonusValue
     */
    constructor(id, title, iconFileName, upgradeCostCalculator, maxCount, totals, goldBonusValue) {
        super(id, title, iconFileName, upgradeCostCalculator, maxCount, totals);

        /**
         * @constant
         * @type {BigNumValue}
         */
        this.goldBonusValue = goldBonusValue;
        
        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedBonus = new BigNum(-10);

        /**
         * @type {string}
         */
        this.description = null;
    }

    /**
     * @override
     * @returns {string}
     */
    getDescription() {

        const goldBonus = this.goldBonusValue.getValue();
        if (!this.description || !goldBonus.equals(this.displayedBonus)) {
            this.displayedBonus.copy(goldBonus);
            this.description = '+' + NumberFormatter.formatBigNum(goldBonus) + '/block';
        }

        return this.description;
    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @override
     * @param {number} currentCount This is the before value.
     * @param {number} purchaseCount 
     */
    onUpgradePurchased(currentCount, purchaseCount) {
        super.onUpgradePurchased(currentCount, purchaseCount);

        this.goldBonusValue.incrementValue(new BigNum(purchaseCount));
    }

}